import React, { useEffect, useState } from "react";
import _ from "lodash";
import AbstractPreview from "./view";
import Api from "../../../../../lib/api";
import { singular } from "../../../../../utils/stringUtils";
import { extractResourceAttributes } from "../../../../../utils/jsonApiUtils";

const fetchEntity = async (entityName, entityId) => {
    const response = await Api.get(`${entityName}/${entityId}`);
    return response;
};

export default function ({ entityObject, options, includedEntities, onFinish }) {
    const [entityData, setEntityData] = useState({ ...entityObject });
    const [isLoading, setIsLoading] = useState(false);
    const [hasErrors, setHasErrors] = useState(null);

    const relations = _.filter(options.previewFields, ["type", "relation"]);

    const assignNewProperties = (relation, entity) => {
        // Iterate over relation fields we're interested in
        _.forEach(relation.fields, (field) => {
            // Construct option property
            const fieldName = `${_.camelCase(singular(relation.collection))}${_.capitalize(field)}`;
            const fieldLabel = `${_.capitalize(singular(relation.collection))}'s ${_.capitalize(
                field
            )}`;
            // Add to options and entityObject the fields
            !_.find(_.flatten(options.previewFields), ["name", fieldName]) &&
                options.previewFields.push({
                    name: fieldName,
                    label: fieldLabel,
                });
            _.assign(entityObject, { [fieldName]: entity[`${field}`] });
            setEntityData({ ...entityObject });
        });
    };

    useEffect(() => {
        _.forEach(relations, (relation) => {
            if (!entityObject[relation.name]) return;

            setIsLoading(true);
            Api.get(`${relation.collection}/${entityObject[relation.name]}`)
                .then((response) => {
                    const { entities } = response;
                    const relatedEntity = _.values(
                        entities[`${_.camelCase(relation.collection)}`]
                    )[0].attributes;
                    assignNewProperties(relation, relatedEntity);
                    setIsLoading(false);
                })
                .catch((error) => {
                    setHasErrors(error);
                    setIsLoading(false);
                });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (options.previewOptions && options.previewOptions.fetchEntity) {
            fetchActiveEntity();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchActiveEntity = async () => {
        setIsLoading(true);
        try {
            const response = await fetchEntity(options.entityName, entityObject.id);
            const entity = response.entities[options.entityName];
            setEntityData({ ...entityObject, ...extractResourceAttributes(entity) });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    return (
        <AbstractPreview
            entityObject={entityData}
            options={options}
            includedEntities={includedEntities}
            isLoading={isLoading}
            errors={hasErrors}
            onCancel={onFinish}
            header={`${_.startCase(singular(options.pageTitle))} ${
                entityObject.id && `#${entityObject.id}`
            } Details`}
        />
    );
}
